export default __webpack_public_path__ + "static/media/LGBTQ2_fr.40127e13.svg";